import { render, staticRenderFns } from "./modalAddAdvertisementAttributes.vue?vue&type=template&id=56a877c7&"
import script from "./modalAddAdvertisementAttributes.vue?vue&type=script&lang=js&"
export * from "./modalAddAdvertisementAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports